import { render, staticRenderFns } from "./set_list.vue?vue&type=template&id=63498385&scoped=true&"
import script from "./set_list.vue?vue&type=script&lang=js&"
export * from "./set_list.vue?vue&type=script&lang=js&"
import style0 from "./set_list.vue?vue&type=style&index=0&id=63498385&prod&lang=scss&"
import style1 from "./set_list.vue?vue&type=style&index=1&id=63498385&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63498385",
  null
  
)

export default component.exports